<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">فرم ثبت اطلاعات کلی حقوق سال '{{inner_Year}}'</h5>
      <form [formGroup]="AddNewSalary" (submit)="SubmitAddNewSalary()">



        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">حقوق پایه</label>
            <input formControlName="Payeh" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Payeh().valid && get_Form_Payeh().touched" class="form-text text-muted MyErrorRedColor">حقوق پایه را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">حق اولاد</label>
            <input formControlName="Farzand" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Farzand().valid && get_Form_Farzand().touched" class="form-text text-muted MyErrorRedColor">حق اولاد را وارد نمائید.</small>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">بن کارگری</label>
            <input formControlName="BonKargari" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_BonKargari().valid && get_Form_BonKargari().touched" class="form-text text-muted MyErrorRedColor">بن کارگری را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">حق مسکن</label>
            <input formControlName="Maskan" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Maskan().valid && get_Form_Maskan().touched" class="form-text text-muted MyErrorRedColor">حق مسکن را وارد نمائید.</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">خواربار</label>
            <input formControlName="Kharbar" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Kharbar().valid && get_Form_Kharbar().touched" class="form-text text-muted MyErrorRedColor">خواربار را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">حق تاهل</label>
            <input formControlName="Tahahol" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Tahahol().valid && get_Form_Tahahol().touched" class="form-text text-muted MyErrorRedColor">حق تاهل را وارد نمائید.</small>
          </div>
        </div>
                <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">فوق العاده پذیرایی </label>
            <input formControlName="Paziraee" type="number" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Paziraee().valid && get_Form_Paziraee().touched" class="form-text text-muted MyErrorRedColor">فوق العاده پذیرایی  را وارد نمائید.</small>
          </div>

        </div>


        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewSalary.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
        <button (click)="onBack()" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
      </form>
  </div>
</div>

